module.exports = __webpack_public_path__ + "static/media/9.07f827c4.png";